import { Skeleton, Typography } from '@mui/material';
import i18next from 'i18next';
import { memo } from 'react';

import { MultiStoreCenter } from '../../../../interface/multi-store';
import { MultiStoreCardFrame } from './multi-store-card-frame';
import { MultiStoreCenterContent } from './multi-store-center-content';

interface MultiStoreStatusCardProps {
  center: MultiStoreCenter;
  // orari del giorno ancora in arrivo; altrimenti richiesta fallita o centro omesso
  isLoading: boolean;
}

// Centro di cui non ci sono ancora gli orari del giorno: segnaposto mentre carica, oppure
// l'avviso che gli orari non sono disponibili al momento
export const MultiStoreStatusCard = memo(function MultiStoreStatusCard({
  center,
  isLoading,
}: MultiStoreStatusCardProps): JSX.Element {
  return (
    <div className="multi-store-static-card" aria-busy={isLoading}>
      <MultiStoreCardFrame>
        <MultiStoreCenterContent
          pointOfSale={center.pointOfSale}
          isOrigin={center.isOrigin}
          distance={center.distance}
          isAddressVisible={false}
        >
          {isLoading ? (
            <>
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="40%" />
            </>
          ) : (
            <Typography variant="contentDescription2">
              {i18next.t('pages.when.multi_store.unavailable')}
            </Typography>
          )}
        </MultiStoreCenterContent>
      </MultiStoreCardFrame>
    </div>
  );
});
